import { useContext, useEffect, useMemo } from "react";

import { SearchOutlined } from "@ant-design/icons";

import { InputFactory } from "../../../../../../../shared/components";

import { StepOneFormContext } from "../../contexts/StepOneForm";
import { MasterContext } from "../../../../../../../shared/contexts";

import { InputFactoryProp, SelectOption } from "../../../../../../../shared/interfaces";

import { COLORS } from "../../../../../../../config/themes/colors";

export const TableFilter = () => {
    const {
        filterForm,
        filterPreliquidationData,
        clearPreliquidationData,
    } = useContext(StepOneFormContext);
    const { branchList } = useContext(MasterContext);

    const onFilterPreliquidations = () => {
        filterPreliquidationData();
    };

    const onClearPreLiquidationsFilter = () => {
        clearPreliquidationData();
    };
    const checkedColumnsOptions: SelectOption[] = useMemo(() => ([
        {
            label: "Todo",
            value: "false"
        },
        {
            label: "Mostrar pólizas seleccionadas",
            value: "true"
        },
    ]), []);
    const inputsFilter: InputFactoryProp[] = useMemo(() => [
        {
            element: 'select',
            isMulti: false,
            placeHolder: 'Rama',
            items: branchList,
            name: 'rama',
        },
        {
            element: 'input',
            type: 'text',
            placeHolder: 'Asegurado',
            icon: <SearchOutlined style={{ color: COLORS.neutrals[50] }} />,
            name: 'asegurado',
        },
        {
            element: 'input',
            type: 'text',
            placeHolder: 'Póliza',
            icon: <SearchOutlined style={{ color: COLORS.neutrals[50] }} />,
            name: 'poliza',
        },
        {
            element: 'select',
            isMulti: false,
            placeHolder: 'Estado',
            name: 'checkedColumns',
            items: checkedColumnsOptions
        },
    ], [
        branchList, checkedColumnsOptions
    ]);

    const initialStateFilters = useMemo(() => ({
        preliquidationNumber: '',
        preLiquidationState: '',
        preliquidationDate: [],
        checkedColumns: 'false',
    }), []);

    useEffect(() => {
        filterForm.setFieldsValue(initialStateFilters);
    }, [filterForm, initialStateFilters]);

    return (
        <InputFactory
            form={filterForm}
            items={inputsFilter}
            initialState={initialStateFilters}
            onFilter={onFilterPreliquidations}
            onClear={onClearPreLiquidationsFilter}
        />
    )
}
